import {
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const ProjectPagination = ({
  currentPage,
  totalPages,
  setCurrentPage,
}) => {
  if (totalPages <= 1) return null;

  const pages = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-4 border-t border-gray-200 px-6 py-4">

      {/* Left */}

      <p className="text-sm text-gray-500">
        Showing page{" "}
        <span className="font-semibold">
          {currentPage}
        </span>{" "}
        of{" "}
        <span className="font-semibold">
          {totalPages}
        </span>
      </p>

      {/* Right */}

      <div className="flex items-center gap-2">

        {/* Previous */}

        <button
          onClick={() =>
            setCurrentPage((prev) =>
              Math.max(prev - 1, 1)
            )
          }
          disabled={currentPage === 1}
          className="
          flex
          items-center
          gap-2
          px-3
          py-2
          rounded-lg
          border
          text-sm
          disabled:opacity-40
          hover:bg-gray-100
          transition
          "
        >
          <ChevronLeft size={16} />

          Previous
        </button>

        {/* Pages */}

        {pages.map((page) => (
          <button
            key={page}
            onClick={() =>
              setCurrentPage(page)
            }
            className={`w-10 h-10 rounded-lg text-sm font-medium transition

            ${
              currentPage === page
                ? "bg-blue-600 text-white"
                : "border hover:bg-gray-100"
            }`}
          >
            {page}
          </button>
        ))}

        {/* Next */}

        <button
          onClick={() =>
            setCurrentPage((prev) =>
              Math.min(prev + 1, totalPages)
            )
          }
          disabled={currentPage === totalPages}
          className="
          flex
          items-center
          gap-2
          px-3
          py-2
          rounded-lg
          border
          text-sm
          disabled:opacity-40
          hover:bg-gray-100
          transition
          "
        >
          Next

          <ChevronRight size={16} />
        </button>

      </div>

    </div>
  );
};

export default ProjectPagination;